
export =
    [{
        "fill": {
				"pattern": {
					"orientation": "cross",
					"color": "rgba(12,236,43,1)",
					"spacing": 7,
					"repitition": "repeat"
				}
			}
    }];